import { createStore, createContainer } from 'react-sweet-state';

import { DEFAULT_ORDER_DIRECTION, DEFAULT_ORDER_FIELD } from '../common/constants';

import * as actions from './actions';
import type { State } from './types';

export type Actions = typeof actions;

export const store = createStore<State, Actions>({
	name: 'issue-attachments',
	initialState: {
		issueAttachments: {},
		meta: {
			orderDirection: DEFAULT_ORDER_DIRECTION,
			orderField: DEFAULT_ORDER_FIELD,
			startAt: 0,
			isDeleteAllDialogOpen: false,
		},
	},
	actions,
});

export const IssueAttachmentStoreContainer = createContainer(store);
